import { render, staticRenderFns } from "./bdpdf.vue?vue&type=template&id=46befb3f&scoped=true"
import script from "./bdpdf.vue?vue&type=script&lang=js"
export * from "./bdpdf.vue?vue&type=script&lang=js"
import style0 from "./bdpdf.vue?vue&type=style&index=0&id=46befb3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46befb3f",
  null
  
)

export default component.exports